import React from "react";
import CreateCampaign from "@/partial/campaign/create-campaign";

const CreateCampaignPage: React.FC = () => {
  return <CreateCampaign />;
};

export default CreateCampaignPage;
